import { Link } from 'react-router-dom';

export default function Navigation() {
  return (
    <nav className="nav" aria-label="Main navigation">
      <div className="nav-inner">
        <Link to="/" className="nav-logo" aria-label="Quit Gooning — Home">
          <img src="/app_logo.png" alt="" className="nav-logo-icon" aria-hidden="true" />
          Quit <span>Gooning</span>
        </Link>
        <div className="nav-right">
          <div className="nav-links">
            <Link to="/support">Support</Link>
            <Link to="/privacy">Privacy</Link>
          </div>
          <a
            href="https://play.google.com/store/apps/details?id=com.extendztech.quit_gooning"
            className="nav-cta"
            target="_blank"
            rel="noopener noreferrer"
          >
            Download Free
          </a>
        </div>
      </div>
    </nav>
  );
}
